import { t } from "../../i18n/t";

/** Error notice with a retry button for the public pages' data fetch. */
export function LoadError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="notice notice-error" role="alert">
      <p>{message}</p>
      <button type="button" className="btn btn-secondary btn-small" onClick={onRetry}>
        {t("common.retry")}
      </button>
    </div>
  );
}
